/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const KeyGenerateType: core.serialization.Schema<serializers.KeyGenerateType.Raw, Truvity.KeyGenerateType> =
    core.serialization.enum_(['ED25519', 'P256', 'P384']);

export declare namespace KeyGenerateType {
    export type Raw = 'ED25519' | 'P256' | 'P384';
}
